import { type AnimationEventHandler, useCallback, useState } from "react";

interface TUseAnimationVisibilityProps {
  animationEndName: string;
}

const useAnimationVisibility = ({
  animationEndName,
}: TUseAnimationVisibilityProps) => {
  const [visibility, setVisibility] = useState({
    isMounted: false,
    isVisible: false,
  });

  const handleOpen = useCallback(() => {
    setVisibility({
      isMounted: true,
      isVisible: true,
    });
  }, []);

  const handleClose = useCallback(() => {
    setVisibility({
      isMounted: true,
      isVisible: false,
    });
  }, []);

  const onAnimationEnd: AnimationEventHandler = useCallback(
    (e) => {
      if (e.animationName === animationEndName) {
        if (visibility.isMounted) {
          setVisibility({
            isMounted: false,
            isVisible: false,
          });
        }
      }
    },
    [animationEndName, visibility.isMounted],
  );

  return {
    visibility,
    handleOpen,
    handleClose,
    onAnimationEnd,
  };
};

export default useAnimationVisibility;
